import { createRootRouteWithContext } from "@tanstack/react-router";
import { Suspense } from "react";

import { Layout } from "@/components/layout";
import { SuspenseLoadingScreen } from "@/components/loading-screen";
import { ProtectedRoute } from "@/providers/hooks/use-protected-route";

type RouterContext = {
    isCapacitor: boolean;
};

export const Route = createRootRouteWithContext<RouterContext>()({
    component: () => (
        <ProtectedRoute>
            <Suspense fallback={<SuspenseLoadingScreen />}>
                <Layout />
            </Suspense>
        </ProtectedRoute>
    ),
});
